import styled from "@emotion/styled";

export const Container = styled.div`
  z-index: 100;
  display: flex;
  width: 200px;
  flex-direction: column;
  position: absolute;
  top: 38px;
  left: 0px;
`;

export const SelectedContainer = styled.div`
  display: flex;
  align-self: stretch;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  padding: 8px 12px;
  min-height: 40px;

  box-sizing: border-box;
  gap: 4px;
  overflow-x: auto;
  border-bottom: 1px solid var(--alias-color-line-normal);
  background-color: var(--alias-color-background-normal-alternative);
  box-shadow: var(--alias-style-shadow-strong);

  ::-webkit-scrollbar {
    background-color: transparent;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: var(--component-color-fill-strong);
  }
`;

export const DropdownContainer = styled.div`
  display: flex;
`;

export const MeetingRoomListContainer = styled.div`
  width: 100%;
  height: 220px;
  display: flex;
  flex-direction: column;
  border-radius: 0px 0px 8px 8px;
  box-shadow: var(--alias-style-shadow-strong);
  box-sizing: border-box;
  background-color: white;
`;

export const ListContainer = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    background-color: white;
    width: 10px;
    padding-right: 6px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: var(--component-color-fill-strong);
  }
`;
